import moment from 'moment';

export const Urls = {
    appointment: {
        getData: '/api/Appointment',
        save: '/api/Appointment'
    },
    coupons: {
        getData: 'api/Coupons',
        getTransmissionService: 'api/Coupons/GetCouponsByType/1',
        getAutoCareService:'api/Coupons/GetCouponsByType/2'
    },
    dealers: {
        get: '/api/DealerLocator',
        getCampaign: '/api/DealerLocator?hasCampaign=true'
    }
}

/**
 * for now it's shared
   later good idea
   to separate api by entities
 */
export default class Api {
    static getAppointmentData() {
        return fetch(Urls.appointment.getData)
            .then((res) => {
                return res.json();
            });
    }

    static submitAppointment(request) {
        return fetch(Urls.appointment.save, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        })
    }
    static getDealers(withCampaign, campaignID) {
        
        if (typeof (withCampaign) == "undefined") {
            withCampaign = false;
        }
        if (withCampaign) {

            return fetch(Urls.dealers.getCampaign + '&campaignId=' + campaignID).then((res) => res.json());
        }
        return fetch(Urls.dealers.get).then((res) => res.json());
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Api.js